import { render, staticRenderFns } from "./ModalVisualizarProtocolosVinculados.vue?vue&type=template&id=360be931&lang=pug"
import script from "./ModalVisualizarProtocolosVinculados.vue?vue&type=script&lang=js"
export * from "./ModalVisualizarProtocolosVinculados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports